import { Notification } from "expo-notifications";

export enum PNActionTypes {
    set = 'SET',
    add = 'ADD',
    remove = 'REMOVE',
    clear = 'CLEAR'
}

export type PNAction =
    | { type: PNActionTypes.clear }
    | {
        type: PNActionTypes.set,
        payload: Notification[]
    }
    | {
        type: PNActionTypes.add,
        payload: Notification
    }
    | {
        type: PNActionTypes.remove,
        payload: string
    }

export interface IPNState {
    notifications: Notification []
}